module.exports = __webpack_public_path__ + "static/img/s130.05ca24aa.png";